/* eslint-disable */
import moment from 'moment';
String.prototype.removeLineEnd = function () {
  return this.replace(/(<.+?\s+?)(?:\n\s*?(.+?=".*?"))/g, '$1 $2')
}
export default {
  getLastMonth() {    // 获取上个月
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth();
    if (!month) {
      year--;
      month = 12;
    }
    return year + (month < 10 ? '0' : '') + month;
  },
  getMonthNow() {    // 获取本月
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    return year + (month < 10 ? '0' : '') + month;
  },
  getDaysNow() {
    return moment().format('YYYYMMDD');
  },
  getDateToday() {
    return moment().format('YYYY-MM-DD');
  },
  getLastDay() {    // 获取昨天年月日
    return moment().subtract(1, 'days').format('YYYYMMDD');
  },
  getDaysBefore(n) {     //获取n天后日期
    return moment().subtract(n, 'days').format('YYYYMMDD');
  },
  getDaysLater(n, date) {     //获取n天后日期
    return moment(date).add(n, 'd').format('YYYY-MM-DD');
  },
  getNameById(id, arr, idAttr, nameAttr) {    // 从arr中根据id获取对应的name
    let name = '';
    if (Array.isArray(arr)) {
      arr.some((v) => {
        if (v[idAttr] == id) {
          name = v[nameAttr];
          return true;
        }
      })
    }
    return name;
  },
  formatTime(value) {     // 格式化到秒
    if (!value) {
      return value;
    }
    return moment(value).format('YYYY-MM-DD HH:mm:ss')
  },
  formatTime2(value) {     // 格式化到秒
    if (!value) {
      return value;
    }
    return moment(value).format('YYYYMMDDHHmmss')
  },
  formatDate(value) {     // 格式化到日期
    if (!value) {
      return value;
    }
    return moment(value).format('YYYYMMDD')
  },
  formatDate2(value) {     // 格式化数据统计日期
    value += '';
    if (!value || value.indexOf(':') > -1) {
      return value;
    }
    let str = value.slice(0, 4) + '-' + value.slice(4, 6) + '-' + value.slice(6, 8);
    str = getDaysLater(1, str);
    return str + ' 00:00:00';
  },
  formatDate3(value) {     // 格式化到日期
    if (!value) {
      return value;
    }
    let formatRst = moment(value).format('YYYYMMDD');
    let str = formatRst.slice(0, 4) + '年' + formatRst.slice(4, 6) + '月' + formatRst.slice(6, 8) + '日';
    return str;
  },
  formatDate4(value) {     // 格式化到2019年1月24日 14:25:00
    if (!value) {
      return value;
    }
    let formatRst = moment(value).format('YYYYMMDDHHmmss');
    let str = formatRst.slice(0, 4) + '年' + formatRst.slice(4, 6) + '月' + formatRst.slice(6, 8) + '日 ' + formatRst.slice(8, 10) + ':' + formatRst.slice(10, 12) + ':' + formatRst.slice(12, 14);
    return str;
  },
  formatDate5(value) {     // 格式化数据统计日期
    return moment(value).format('YYYY-MM-DD')
  },
  formatDate6(value) {     // 格式化数据统计日期
    return moment(value).format('YYYY.MM.DD')
  },
  formatDate7(value) {     // 格式化数据统计日期
    return moment(value).format('E');
  },
  showNames(arr, name, split = ',') { // 拼接对象数组中的某个属性返回
    if (!arr || !arr.map) {
      return '';
    }
    return arr.map((v) => {
      return v[name];
    }).join(split);
  },
  fillStartZero(value, len = 4) {     // 数字前补零
    let count = len - (value + '').length;
    return '0'.repeat(count > 0 ? count : 0) + value;
  },
  getDaysAgo(n, date) {     //获取n天前日期
    return moment(date).subtract(n, 'd').format('YYYYMMDD');
  },
  getMonthsAgo(n, date) {   //获取n个月前日期
    return moment(date).subtract(n, 'M').format('YYYY-MM-DD');
  },
  getMonthsAgo2(n, date) {   //获取n个月前日期
    return moment(date).subtract(n, 'M').format('YYYYMMDD');
  },
  formatDateNum(dateNum, symbol) {
    if (!dateNum) {
      return '';
    }
    symbol = symbol || '-';
    dateNum += '';
    let result = [dateNum.slice(0, 4), dateNum.slice(4, 6), dateNum.slice(6, 8)];
    if ((new Date()).getFullYear() == result[0]) {
      result.shift();
    }
    return result.join(symbol);
  },
  formatMonthNum(dateNum) {
    if (!dateNum) {
      return '';
    }
    dateNum += '';
    let result = [dateNum.slice(0, 4), dateNum.slice(4, 6) + '月'];
    if ((new Date()).getFullYear() == result[0]) {
      result.shift();
    }
    return result.join('年');
  },
  formatMonth(str) {
    str += '';
    return str.slice(0, 4) + '年' + str.slice(4) + '月';
  },
  formatDisDayNum(endDate, startDate) {
    let result1 = [endDate.slice(0, 4), endDate.slice(4, 6), endDate.slice(6, 8)];
    let result2 = [startDate.slice(0, 4), startDate.slice(4, 6), startDate.slice(6, 8)];
    result1 = result1.join("-");
    result2 = result2.join("-");
    let date1 = new Date(result1);
    let date2 = new Date(result2);
    let num = (date1 - date2) / (1000 * 60 * 60 * 24) + 1;
    return num;
  },
  formatPercent(num) {
    if (isNaN(num) || isNaN(+num) || !isFinite(+num)) {
      return 0;
    }
    return (num * 100).toFixed(2) + '%';
  },
  formatNum(num) {
    if (isNaN(num) || isNaN(+num) || !isFinite(+num)) {
      return 0;
    }
    return ('' + num).replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,')
  },
  formatBigScreenAmount(num) {
    if (isNaN(num) || isNaN(+num) || !isFinite(+num)) {
      return 0;
    }
    num = Math.round(num);
    return ('' + num).replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,')
  },
  formatAmount(value) {
    let realValue = Number(value).toFixed(2);
    return Number(realValue);
  },
  //格式化xml
  formatXml(text) {
    //去掉多余的空格
    if (typeof (text) != 'string') return "";
    text = '\n' + text.replace(/(<\w+)(\s.*?>)/g, function ($0, name, props) {
      return name + ' ' + props.replace(/\s+(\w+=)/g, " $1");
    }).replace(/>\s*?</g, ">\n<");

    //把注释编码
    text = text.replace(/\n/g, '\r').replace(/<!--(.+?)-->/g, function ($0, text) {
      var ret = '<!--' + escape(text) + '-->';
      //alert(ret);
      return ret;
    }).replace(/\r/g, '\n');

    //调整格式
    var rgx = /\n(<(([^\?]).+?)(?:\s|\s*?>|\s*?(\/)>)(?:.*?(?:(?:(\/)>)|(?:<(\/)\2>)))?)/mg;
    var nodeStack = [];
    var output = text.replace(rgx, function ($0, all, name, isBegin, isCloseFull1, isCloseFull2, isFull1, isFull2) {
      var isClosed = (isCloseFull1 == '/') || (isCloseFull2 == '/') || (isFull1 == '/') || (isFull2 == '/');
      //alert([all,isClosed].join('='));
      var prefix = '';
      if (isBegin == '!') {
        prefix = getPrefix(nodeStack.length);
      }
      else {
        if (isBegin != '/') {
          prefix = getPrefix(nodeStack.length);
          if (!isClosed) {
            nodeStack.push(name);
          }
        }
        else {
          nodeStack.pop();
          prefix = getPrefix(nodeStack.length);
        }

      }
      var ret = '\n' + prefix + all;
      return ret;
    });

    var prefixSpace = -1;
    var outputText = output.substring(1);
    //alert(outputText);

    //把注释还原并解码，调格式
    outputText = outputText.replace(/\n/g, '\r').replace(/(\s*)<!--(.+?)-->/g, function ($0, prefix, text) {
      //alert(['[',prefix,']=',prefix.length].join(''));
      if (prefix.charAt(0) == '\r')
        prefix = prefix.substring(1);
      text = unescape(text).replace(/\r/g, '\n');
      var ret = '\n' + prefix + '<!--' + text.replace(/^\s*/mg, prefix) + '-->';
      //alert(ret);
      return ret;
    });

    return outputText.replace(/\s+$/g, '').replace(/\r/g, '\r\n');
  },
  //数组对象去重
  unique(arr, attr) {
    let obj = {};
    let newArr = Object.assign([], arr)
    let peon = newArr.reduce((cur, next) => {
      obj[next[attr]] ? "" : obj[next[attr]] = true && cur.push(next);
      return cur;
    }, [])
    return peon;
  },
  //处理大数据列表
  dealList(arr, newActiveGroupId) {
    let newList = arr.map((obj) => {
      let o = {};
      o.date_num = obj.date_num;
      o.env = obj.env;
      for (let key in obj) {
        let arr = key.split("_");
        if (arr.length >= 3 && arr[1] == newActiveGroupId) {
          let name = arr[3] ? arr[2] + "_" + arr[3] : arr[2];
          o[name] = obj[key]
        }
      }
      return o;
    })
    return newList;
  },
  //数组排序+填补空缺数据
  sortList(arr, attr) {
    arr.sort((a, b) => {
      return (b[attr] - a[attr]);
    })
    return arr;
  },
  //检验数据是否完整
  testList(list, attr, date, standBy = {}, env) {
    let arr = list;
    let endDate = date[1];
    let startDate = date[0];
    let dateList = [];
    while (endDate >= startDate) {
      dateList.push(endDate)
      endDate = this.getDaysAgo(1, endDate)
    }
    let nowObj = arr[0] ? arr[0] : Object.assign({}, standBy);
    nowObj.env = env;
    dateList.forEach((item, idx) => {
      if (arr[idx]) {
        if (arr[idx][attr] != item) {
          let obj = Object.assign({}, nowObj);
          for (let key in obj) {
            if (key == attr) {
              obj[key] = parseInt(item);
            } else if (key != 'env') {
              obj[key] = 0;
            }
          }
          arr.splice(idx, 0, obj)
        }
      } else {
        let obj = Object.assign({}, nowObj);
        for (let key in obj) {
          if (key == attr) {
            obj[key] = parseInt(item);
          } else if (key != 'env') {
            obj[key] = 0;
          }
        }
        arr.push(obj)
      }

    })
    return arr;
  },
  //获取每月最后一天数据
  getMonthLastDayDate(dataList, attr, date) {
    let list = [];
    dataList = [...dataList];
    dataList.forEach((item) => {
      if (isLastDay(item.date_num.toString())) {
        list.push(item)
      }
    })
    return list;
  },
}
function isLastDay(inputDate) {
  var date = inputDate.slice(0, 4) + '/' + inputDate.slice(4, 6) + '-' + inputDate.slice(6);
  var d = new Date(date);
  var nd = new Date(d.getTime() + 24 * 60 * 60 * 1000); //next day
  return (d.getMonth() != nd.getMonth())

}

function getPrefix(prefixIndex) {
  var span = '    ';
  var output = [];
  for (var i = 0; i < prefixIndex; ++i) {
    output.push(span);
  }

  return output.join('');
}



// WEBPACK FOOTER //
// ./src/filter/index.js